// 设置页面所处环境
export const SET_ENV ='setEnvironment'

// 记录手机号
export const SET_CELLPHONE = 'setCellphone'

// 设置活动详情
export const SET_ACTIVITYDATA = 'setActivityData'

// 设置报名信息
export const SET_FILLINFO = 'setFillinfo'

// 设置课程详情
export const SET_LESSON = 'setLesson'

// 设置推荐人信息
export const SET_PROFILE = 'profile'



// WEBPACK FOOTER //
// ./src/store/types.js